import { defineComponent as _defineComponent } from 'vue'
import BulkCreateForm from './BulkCreateForm.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'BulkCreate',
  setup(__props) {


return { __sfc: true,BulkCreateForm }
}

})